<template>
  <div class="container box-login">
    <img src="@/assets/images/logoLogin.png" class="logo" alt="" srcset="" />
    <h6 class="center-align" style="color: #BCBCBC">
      Insira senha e confirmação para recuperar sua conta.
    </h6>
    <div class="title-divider" />
    <form @submit.prevent="resetPassword" style="max-width: 400px">
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12">
          <input
            type="text"
            v-model="form.email"
            name="email"
            v-validate="'required|email'"
            :class="{ invalid: errors.first('email') }"
            readonly
          />
          <span class="helper-text" :data-error="errors.first('email')"></span>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0">
        <div class="input-field col s12">
          <label for="password">Senha</label>
          <input
            type="password"
            v-model="form.password"
            name="password"
            id="password"
            v-validate="'required|min:8'"
            :class="{ invalid: errors.first('password') }"
            ref="password"
          />
          <span
            class="helper-text"
            :data-error="errors.first('password')"
          ></span>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12">
          <label for="password_confirmation">Confirmar senha</label>
          <input
            type="password"
            v-model="form.password_confirmation"
            name="password_confirmation"
            id="password_confirmation"
            v-validate="'required|confirmed:password'"
            :class="{ invalid: errors.first('password_confirmation') }"
          />
          <span
            class="helper-text"
            :data-error="errors.first('password_confirmation')"
          ></span>
        </div>
      </div>

      <div class="actions">
        <a
          class="waves-effect btn-large flat"
          @click="$router.push('/login')"
          v-show="!load"
          >Cancelar</a
        >
        <button
          class="waves-effect waves-light btn-large"
          type="submit"
          :class="{ load: load }"
        >
          <feather v-if="load" type="loader" animation="spin" />
          <template v-else
            >Restaurar</template
          >
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  data: () => ({
    load: false,
    form: {
      email: "",
      token: "",
      password: "",
      password_confirmation: ""
    }
  }),
  mounted() {
    const { email, token } = this.$route.query;
    if (!email && !token) {
      M.toast({
        html: "Link de recuração de senha inválido.",
        displayLength: 3000
      });
      this.$router.push("/");
    } else {
      this.form.email = email;
      this.form.token = token;
    }
  },
  methods: {
    async resetPassword() {
      await this.$validator.validateAll();
      if (!this.errors.items.length > 0) {
        this.load = true;
        try {
          await this.$http.post("auth/reset", { ...this.form });
          M.toast({
            html: "Senha redefinida com sucesso.",
            displayLength: 3000
          });
          document.querySelector(".toast").classList.add("success");
        } catch (e) {
          M.toast({
            html: "Error ao redefinir, por favor tentar novamente mais tarde.",
            displayLength: 3000
          });
        }
        this.load = false;
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables.scss";

.title-divider {
  height: 50px;
}

.box-login {
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    margin-bottom: 24px;
  }
  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    button,
    a {
      width: 35vh;
    }

    button {
      margin-left: 10px;
    }
  }

  @media #{$small-and-down} {
    .actions {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column-reverse;
      button,
      a {
        width: 100%;
      }
      button {
        margin-bottom: 20px;
        margin-left: 0;
      }
    }
  }
}
</style>
